$hyoo_js_perf $mol_book2
	yard $hyoo_sync_client
	bench_id null
	bench $hyoo_js_perf_bench
	titles /string
	prefixes /string
	sources /string
	menu_title @ \Title
	permalink \
	plugins /
		<= Theme $mol_theme_auto
		<= Hotkey $mol_hotkey
			mod_ctrl true
			key * enter?event <=> run?event null
	pages /
		<= Common $mol_page
			title @ \JS Benchmark
			tools <= menu_tools /
			foot /
				<= Online $hyoo_sync_online
					yard <= yard
				<= Source $mol_link_source
					uri \https://github.com/hyoo-ru/perf.js.hyoo.ru
				<= About $mol_link
					uri \https://page.hyoo.ru/#!=btunlj_fp1tum
					sub /
						<= About_icon $mol_icon_help_circle_outline
				<= Lights $mol_lights_toggle
			body /
				<= Common_content $mol_list rows /
					<= Prefix $mol_labeler
						title @ \Common Setup
						Content <= Prefix_code $mol_textarea
							enabled <= changable true
							spellcheck false
							value?val <=> prefix?val \
							hint \let res = 0
					<= Postfix $mol_labeler
						title @ \Common Teardown
						Content <= Postfix_code $mol_textarea
							enabled <= changable true
							spellcheck false
							value?val <=> postfix?val \
							hint \$mol_assert_like( res, {#} - 1 )
					<= Hint $mol_text text <= hint \
						\### Results Legend
						\🔠 Source Size 📦 Bundle Size
						\🥶 Cold Run 🥵 Hot Run
						\
						\### Iterations count / number
						\	{#}
						\
						\### Load generic Script
						\
						\	const { some } = $mol_import.script(
						\		'https://unpkg.org/...'
						\	)
						\
						\### Load ESM Module
						\
						\	const { some } = $mol_import.module(
						\		'https://esm.sh/...'
						\	).default
						\
						\### Assert equality
						\
						\	$mol_assert_like( [777], [777] )
						\
						\### Measure memory
						\
						\Call Chrome with:
						\	--js-flags="--expose-gc"
						\	--enable-precise-memory-info
						\
						\### Other JS Tools
						\
						\[V8 Optimizations](https://opt.js.hyoo.ru/) [Sandbox](https://eval.js.hyoo.ru)
		<= Cases_pane $mol_page
			title <= bench_title
			Title <= Title $mol_string_button
				value? <=> bench_title? \
				hint <= menu_title
				enabled <= changable
			body /
				<= Cases $mol_list rows <= cases /
					<= Case*0 $hyoo_js_perf_case_row
						title? <=> case_title*? \
						prefix? <=> case_prefix*? \
						source? <=> source*? \
						measurable? <=> case_measurable*? true
						Measurable => Case_measurable*
						sample <= case_sample* \
						results? <=> results*? /
						changable <= changable true
						drop? <=> case_drop*? null
						dupe? <=> case_dupe*? null
						swap? <=> case_swap*? null
			tools /
				- <= Filter $mol_search
					hint @ \Filter
					query? <=> filter? \
				<= Tool_buttons $mol_view sub /
					<= Measurable_all $mol_check_group
						checks <= measurable_all /
						hint @ \Whether to measure all
					<= Run $mol_button_major
						hint @ \Run
						click?event <=> run?event null
						sub / <= Run_icon $mol_icon_play
					<= Share $mol_button_share
						capture <= Cases
					<= Fork $mol_button_minor
						hint @ \Fork benchmark
						click? <=> bench_fork? null
						sub /
							<= Fork_icon $mol_icon_directions_fork
					<= New $mol_button_minor
						hint @ \New benchmark
						click? <=> bench_new? null
						sub /
							<= New_icon $mol_icon_plus_box
